import { Component, OnInit, ViewChild, ViewEncapsulation } from '@angular/core';
import { LazyLoadEvent, MessageService, SelectItem } from 'primeng';
import { BillingService } from '../../services';
import { SupplierAdhocInvoiceComponent } from './supplier-adhoc-invoice.component';
import { SuppliersBatchesComponent } from './suppliers-batches.component';
import { SuppliersInvoicesGridComponent } from './suppliers-invoices-grid.component';
import { XeroSettingsService } from '../../services';
import { UserService } from 'src/app/services/user.service';

@Component({
  selector: 'manage-invoices',
  templateUrl: './manage-invoices.component.html',
  styleUrls: ['./manage-invoices.component.scss'],
  encapsulation: ViewEncapsulation.None,
})
//@SupplierInvoiceProcessingTypeEnumAware
export class ManageInvoicesComponent implements OnInit {
  @ViewChild('gridBatches')
  gridBatches: SuppliersBatchesComponent;

  @ViewChild('gridFailed')
  gridFailed: SuppliersInvoicesGridComponent;

  @ViewChild('gridCancelled')
  gridCancelled: SuppliersInvoicesGridComponent;

  @ViewChild('gridUnbatchedInvoice')
  gridUnbatchedInvoice: SuppliersInvoicesGridComponent;

  @ViewChild('gridInvoices')
  gridInvoices: SuppliersInvoicesGridComponent;

  @ViewChild('gridSupplierAdhocInvoices')
  gridSupplierAdhocInvoices: SupplierAdhocInvoiceComponent;

  public xeroTokenRecordFound: boolean = true;

  public invoiceSuppliers: SelectItem[] = [];
  public isFinanceUser = false;
  constructor(
    public messageService: MessageService,
    public xeroSettingsService: XeroSettingsService,
    private billingService: BillingService,
    private userService: UserService,
  ) {}

  async ngOnInit() {
    this.billingService.bindSuppliers().then((res) => {
      this.invoiceSuppliers = res;
    });

    this.xeroSettingsService.FetchAllTokens().then((x) => {
      this.xeroTokenRecordFound = x != null;
    });

    // check if user is in restricted 'finance' role
    this.isFinanceUser = await this.userService.isUserInRole('FINC');
  }

  onGridAction(gridActionId: number) {
    this.gridBatches.gridActionUpdate(gridActionId);
    this.gridFailed.gridActionUpdate(gridActionId);
    this.gridCancelled.gridActionUpdate(gridActionId);
    this.gridUnbatchedInvoice.gridActionUpdate(gridActionId);
    this.gridInvoices.gridActionUpdate(gridActionId);
  }
}
